import { createMutationHelper } from '@utils/swr'
import { type ECommerceValidateInvoiceRequest } from '../types/apiRequest'
import { type ECommerceValidateInvoiceResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

export const {
  useMutation: useApiECommerceValidateInvoice,
} = createMutationHelper<ECommerceV2Apis['post']['validateInvoice'], ECommerceValidateInvoiceResponse, ECommerceValidateInvoiceRequest>({
  client: 'eCommerceV2',
  key: '/:country_code/invoice/validate',
  fetcher: (_url, { arg, client }) => {
    return client.post(`/${arg.country_code}/invoice/validate`, { type: arg.type, value: arg.value })
  },
})
